import { Component } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-link-sent-success-dialog",
  templateUrl: "./link-sent-success-dialog.component.html",
  styleUrls: ["./link-sent-success-dialog.component.css"],
})
export class LinkSentSuccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LinkSentSuccessDialogComponent>,
    private router: Router,
  ) {}

  onGoToPayments() {
    this.dialogRef.close();
    this.router.navigate(["/careplus/careplus-employee-payment"]);
  }
}
